module.exports = __webpack_public_path__ + "img/skirt side seam.38de3490.png";